var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSearchB(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "search-b") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Patient-Registration-Physician-Medication",
    transform: "translate(-307.000000, -121.000000)",
    fill: "#0078BF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "search-b",
    transform: "translate(307.000000, 121.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.8085937,12.0814815 L11.0824219,9.36062378 C10.959375,9.23781676 10.7925781,9.16959064 10.6175781,9.16959064 L10.171875,9.16959064 C10.9265625,8.20623782 11.375,6.99454191 11.375,5.67641326 C11.375,2.54074074 8.82929687,0 5.6875,0 C2.54570313,0 0,2.54074074 0,5.67641326 C0,8.81208577 2.54570312,11.3528265 5.6875,11.3528265 C7.00820312,11.3528265 8.22226562,10.9052632 9.1875,10.1520468 L9.1875,10.5968811 C9.1875,10.77154 9.25585937,10.9380117 9.37890625,11.0608187 L12.1050781,13.7816764 C12.3621094,14.0382066 12.7777344,14.0382066 13.0320312,13.7816764 L13.8058594,13.0093567 C14.0628906,12.7528265 14.0628906,12.3380117 13.8085937,12.0814815 Z M5.6875,9.16959064 C3.75429688,9.16959064 2.1875,7.608577 2.1875,5.67641326 C2.1875,3.74697856 3.7515625,2.18323587 5.6875,2.18323587 C7.62070312,2.18323587 9.1875,3.74424951 9.1875,5.67641326 C9.1875,7.60584795 7.6234375,9.16959064 5.6875,9.16959064 Z",
    id: "Shape"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchB);
export default __webpack_public_path__ + "static/media/search-b.3d915e556c3eb89e86df39908414149c.svg";
export { ForwardRef as ReactComponent };